/* PROJ-99 Phase 6 — Gemeinsamer Bearbeiten-Baustein der POSTER-Editoren der geteilten Pipeline
 * ==========================================================================================
 * Gegenstueck zu assets/cart-edit.js (dem editor-unabhaengigen Helfer): dort liegt der
 * Warenkorb-Teil (Zeile finden, Job-Konfiguration vom Render-Server holen, Knopftext, alte
 * Zeile entfernen, Drawer oeffnen). Hier liegt alles, was in JEDEM Poster-Editor der
 * geteilten Pipeline (Geburts-, Kalender-, Jahreszahlen-, Familien-, Film-, Magazin-, Song-,
 * Vinyl-Poster, Geldgeschenke, Laender, Zuhause, Kiss/Swipe, Collage, Foto-Buchstaben,
 * Wunschwort) gleich ist:
 *
 *   1. Modus-Erkennung am `edit`-Parameter                 -> istModus
 *   2. Ladesperre am Warenkorb-Knopf (I1)                  -> knopfSperren()
 *   3. Warten auf `DLCartEdit.bereit`, Produktpruefung,
 *      „Einige Angaben ..."-Hinweis, Knopf umbenennen      -> starten()
 *   4. Eingabefeld setzen UND die Handler ausloesen        -> feldSetzen() / feldSetzenElement()
 *   5. Kachel/Knopf anklicken statt Zustand direkt setzen  -> kachelKlicken()
 *   6. Produktart + Groesse + Rahmenfarbe aus der Config   -> formatAnwenden()
 *   7. CSS.escape-Ersatz fuer Selektorwerte                -> selektorWert()
 *   8. Zuschnitt-Rechteck aus der Config pruefen           -> zuschnittLesen()
 *
 * Warum KLICKEN statt `state` direkt zu setzen (gleiche Entscheidung wie citymap.js
 * konfigurationAnwenden): die Klick-Handler der Editoren tragen Folgewirkungen — der
 * Produktart-Reiter blendet das passende Groessen-Panel ein, der Groessen-Klick setzt
 * variant_id, Preis und Buehnenformat, der Farb-Handler rendert neu. Wer nur `state`
 * schreibt, hat eine Oberflaeche, die etwas anderes zeigt, als der Zustand enthaelt.
 *
 * Editor-spezifisch bleibt NUR die Feld-Abbildung (die `anwenden`-Funktion) — genau wie bei
 * assets/jewelry-bearbeiten.js fuer die Schmuck-Editoren. Warum eine zweite Datei statt jener:
 * das Schmuck-Modul prueft `produkt`/`version` aus `_config_json` und setzt Kacheln OHNE
 * Klick (die Schmuck-Editoren rendern am Ende gebuendelt); hier kommt die Konfiguration als
 * Render-Payload vom Server (`config.product`), und die Editoren brauchen die echten Klicks.
 * Zwei Bauarten, zwei kleine Bausteine, statt eines mit Weichen fuer beide.
 *
 * Klassisches Skript (kein Modul): die Sections laden es VOR dem Editor-Skript, das es dann als
 * `window.DLPosterBearbeiten` vorfindet. Diese Datei feuert NIE `cart:change` (PROJ-96-Falle)
 * und fasst den Warenkorb nicht an.
 */
(function () {
	'use strict';

	/* ---------------------------------------------------------------- Texte */

	/* Der einzige fest verdrahtete Text dieses Bausteins (Stoerungsmeldung, kein Shop-Text mit
	   Theme-Einstellung — gleiche Begruendung wie in cart-edit.js). Wortgleich mit
	   jewelry-bearbeiten.js, citymap.js und starmap-celestial.js. */
	var HINWEIS_TEILWEISE = 'Einige Angaben konnten nicht übernommen werden.';

	/* ---------------------------------------------------------------- Modus */

	/* Dieselbe Quelle wie in allen Editoren (PROJ-44): das Inline-Skript der Section merged
	   preset_params und echte URL-Parameter nach window.DLEditorSearch. Am PARAMETER statt an
	   window.DLCartEdit, weil der Helfer sich bei einer verschwundenen Zeile asynchron wieder
	   abschaltet (Begruendung in jewelry-bearbeiten.js). */
	var parameter = new URLSearchParams(window.DLEditorSearch || window.location.search);
	var IST_MODUS = parameter.get('edit') !== null;

	/* Die Warenkorbzeile, die gerade bearbeitet wird (gesetzt in starten()). Manche Angaben
	   stehen NICHT im Render-Payload, wohl aber als Eigenschaft der Zeile — z. B. die Rahmenfarbe
	   (`_Frame Color`), die der Server nicht braucht. formatAnwenden() faellt darauf zurueck. */
	var aktuelleZeile = null;

	/* ---------------------------------------------------------------- Selektoren */

	function selektorWert(wert) {
		var text = String(wert == null ? '' : wert);
		if (typeof CSS !== 'undefined' && CSS && typeof CSS.escape === 'function') return CSS.escape(text);
		return text.replace(/["'\\\]\[\(\):;,.#>+~*=^$|\s]/g, function (z) { return '\\' + z; });
	}

	/* ---------------------------------------------------------------- Zuschnitt */

	/* Zuschnitt-Rechteck aus der Konfiguration lesen: vier Zahlen in 0..1, sonst null
	   (= ungeschnitten). Reine Funktion ohne jedes Editor-Wissen — vier Zahlen rein, geklammertes
	   Rechteck raus —, deshalb hier und nicht als Kopie in jedem Foto-Editor (Film-, Magazin-,
	   Song-, Collage-, Foto-Buchstaben-, Wunschwort-Poster).
	   Warum ueberhaupt pruefen: die Editoren rechnen mit dem Ergebnis direkt weiter
	   (applyCropStyles/applyCrop) UND schreiben es unveraendert in den naechsten Render-Payload.
	   Ein kaputter Wert zerlegte also die Buehne und ginge obendrein in den Druckauftrag.
	   Dieselben Klammern wie in den applyCrop-Pfaden der Editoren. */
	function zuschnittLesen(roh) {
		if (!roh || typeof roh !== 'object') return null;
		var x = parseFloat(roh.x), y = parseFloat(roh.y), w = parseFloat(roh.w), h = parseFloat(roh.h);
		if (!isFinite(x) || !isFinite(y) || !isFinite(w) || !isFinite(h)) return null;
		if (!(w > 0) || !(h > 0)) return null;
		return {
			x: Math.max(0, Math.min(1, x)),
			y: Math.max(0, Math.min(1, y)),
			w: Math.max(0.01, Math.min(1, w)),
			h: Math.max(0.01, Math.min(1, h))
		};
	}

	/* ---------------------------------------------------------------- Felder */

	/* Eingabefeld setzen UND `input` + `change` ausloesen: die Editoren haengen ihren Zustand
	   per bindField()/addEventListener('input') an genau diese Ereignisse. `.value` allein
	   liesse `state` auf dem alten Wert stehen und die Buehne unveraendert. Rueckgabe false,
	   wenn es das Feld nicht gibt — dann fehlt im Markup etwas, und der Kunde soll den Hinweis
	   sehen statt still einen leeren Editor. */
	function feldSetzen(id, wert) {
		return feldSetzenElement(document.getElementById(id), wert);
	}

	/* Dasselbe fuer ein Element, das der Editor schon in der Hand hat (dynamisch erzeugte Zeilen
	   ohne feste ID: Personen im Jahreszahlen-Poster, Namenszeilen im Familien-Poster). */
	function feldSetzenElement(el, wert) {
		if (!el) return false;
		if (el.type === 'checkbox') {
			el.checked = !!wert;
		} else {
			el.value = wert == null ? '' : String(wert);
		}
		el.dispatchEvent(new Event('input', { bubbles: true }));
		el.dispatchEvent(new Event('change', { bubbles: true }));
		return true;
	}

	/* Kachel/Knopf mit <attribut>="<wert>" anklicken, wenn sie existiert und nicht schon
	   `current` ist. `wurzel` ist der Editor-Wrapper. Gibt es die Kachelgruppe im Markup gar
	   nicht, gilt das NICHT als Fehler (dann ist an der Oberflaeche nichts zu zeigen);
	   gibt es die Gruppe, aber nicht diesen Wert (entfernte Option, alte Zeile), ist es einer. */
	function kachelKlicken(wurzel, selektor, attribut, wert) {
		if (!wurzel) return false;
		var alle = wurzel.querySelectorAll(selektor + '[' + attribut + ']');
		if (!alle.length) return true;
		var treffer = wurzel.querySelector(selektor + '[' + attribut + '="' + selektorWert(wert) + '"]');
		if (!treffer) return false;
		if (!treffer.classList.contains('current')) treffer.click();
		return true;
	}

	/* Produktart, Groesse und Rahmenfarbe aus der Config. Der Render-Payload traegt die
	   Produktart nicht als Text, wohl aber `variant_id` und `paper_size`: die Groessen-Kachel
	   mit dieser Varianten-ID steht in genau EINEM Groessen-Panel (.el__format[data-id]), und
	   dessen data-id ist die Produktart-Kachel im tab__switcher. Reihenfolge ist Pflicht:
	   erst die Produktart (blendet das Panel ein und waehlt eine Standardgroesse), dann die
	   Groesse, dann die Rahmenfarbe (nur bei Holzrahmen sichtbar).
	   Rueckgabe { angewendet: [...], fehlend: [...] } fuer die Felder variant_id / paper_size /
	   frame_color. */
	function formatAnwenden(wurzel, config) {
		var angewendet = [], fehlend = [];
		if (!wurzel || !config) return { angewendet: angewendet, fehlend: ['config'] };

		var variantId = config.variant_id != null ? String(config.variant_id) : '';
		var groesse = config.paper_size != null ? String(config.paper_size) : '';
		var groessenKachel = null;
		if (variantId) {
			groessenKachel = wurzel.querySelector('.el__format .size__picker a[data-variant-id="' + selektorWert(variantId) + '"]');
		}
		if (!groessenKachel && groesse) {
			/* Rueckfall: gleiche Groesse im gerade sichtbaren Panel (alte Zeile ohne Variante). */
			var sichtbar = null;
			var panels = wurzel.querySelectorAll('.el__format');
			for (var i = 0; i < panels.length; i++) {
				if (panels[i].style.display !== 'none') { sichtbar = panels[i]; break; }
			}
			if (sichtbar) groessenKachel = sichtbar.querySelector('.size__picker a[data-size="' + selektorWert(groesse) + '"]');
		}
		if (!groessenKachel) {
			fehlend.push('variant_id');
			return { angewendet: angewendet, fehlend: fehlend };
		}

		var panel = groessenKachel.closest('.el__format');
		var panelId = panel ? panel.getAttribute('data-id') : null;
		if (panelId) {
			var produktart = wurzel.querySelector('.tab__switcher a[data-id="' + selektorWert(panelId) + '"]');
			if (produktart) {
				if (!produktart.classList.contains('current')) produktart.click();
				angewendet.push('product_type');
			}
		}
		if (!groessenKachel.classList.contains('current')) groessenKachel.click();
		angewendet.push('variant_id');

		/* Rahmenfarbe: die Twins schreiben sie nicht in den Render-Payload (der Server druckt
		   kein Rahmenbild), sondern als Zeilen-Eigenschaft `_Frame Color` — und nur bei
		   Holzrahmen. Config zuerst, dann die Zeile; steht nirgends etwas, gibt es nichts zu
		   uebernehmen (kein Fehler). */
		var rahmenfarbe = config.frame_color;
		if (!rahmenfarbe && aktuelleZeile && aktuelleZeile.properties) rahmenfarbe = aktuelleZeile.properties['_Frame Color'];
		if (rahmenfarbe) {
			var rahmen = wurzel.querySelector('a[data-frame-color="' + selektorWert(rahmenfarbe) + '"]');
			if (rahmen) {
				if (!rahmen.classList.contains('current')) rahmen.click();
				angewendet.push('frame_color');
			} else {
				fehlend.push('frame_color');
			}
		}
		return { angewendet: angewendet, fehlend: fehlend };
	}

	/* ---------------------------------------------------------------- Knopf-Ladesperre */

	/* PROJ-99 (I1): jeder Editor ruft das als ERSTES in init(), bevor er rendert. Bis starten()
	   den Warenkorb-Zustand angewendet hat, zeigt der Editor seinen Default-Stand — ein Klick in
	   dieser Zeit legte genau den ein, und abschliessen() raeumte danach das Kundenmotiv weg.
	   Die eigentliche Sperre liegt in cart-edit.js; hier nur die Weiche fuer Modus und Null. */
	function knopfSperren(knopf) {
		if (!IST_MODUS) return false;
		var helfer = window.DLCartEdit;
		if (!helfer) return false;
		helfer.knopfSperren(knopf);
		return true;
	}

	/* ---------------------------------------------------------------- Start */

	/* optionen = {
	 *   name:     'kalender-poster'            fuer Konsolenmeldungen
	 *   produkt:  'kalenderposter'             MUSS config.product sein (= Familie des Servers)
	 *   anwenden: function (config, zeile) -> { angewendet: [], fehlend: [] }   (darf async sein)
	 *   knopf:    HTMLElement                  der ECHTE Warenkorb-Knopf des Editors
	 * }
	 * Rueckgabe: Promise<boolean> — true heisst „Bearbeiten-Modus laeuft, der naechste
	 * Warenkorb-Klick ersetzt die alte Zeile".
	 */
	async function starten(optionen) {
		if (!IST_MODUS) return false;
		var helfer = window.DLCartEdit;
		if (!helfer) return false;

		var config = await helfer.bereit;
		/* Zeile weg oder Konfiguration nicht ladbar: der Helfer hat abgeschaltet und seinen
		   eigenen Hinweis gezeigt — der Editor ist ein normaler Editor. */
		if (!config) return false;
		if (!window.DLCartEdit) return false;
		aktuelleZeile = helfer.line || null;

		/* Der Server meldet die Familie aus `config.product`; die Zeile kann trotzdem zu einem
		   anderen Produkt gehoeren (Bearbeiten-Link zeigt auf diese Seite, Zeile ist ein
		   Geburtsposter). Lieber gar nicht anwenden als ein fremdes Motiv ueberschreiben. */
		var produkt = config.product != null ? String(config.product) : String(helfer.familie || '');
		if (produkt !== optionen.produkt) {
			console.warn('[PROJ-99] ' + optionen.name + ': Warenkorbzeile gehoert zu "' + produkt + '", nicht zu "' + optionen.produkt + '" — Bearbeiten-Modus aus.');
			helfer.hinweis(helfer.HINWEIS_ANDERES_PRODUKT);
			/* I1: erst den Knopf aus der Ladesperre holen, dann den Modus abschalten — danach
			   ist der Helfer ueber window.DLCartEdit nicht mehr erreichbar. */
			helfer.knopfFreigeben();
			window.DLCartEdit = null;
			window.__dlBearbeitenErgebnis = { ok: false, grund: 'produkt=' + produkt };
			return false;
		}

		var ergebnis;
		try {
			ergebnis = await optionen.anwenden(config, helfer.line);
		} catch (e) {
			console.error('[PROJ-99] ' + optionen.name + ': Bearbeiten-Modus konnte nicht vollstaendig hergestellt werden:', e);
			ergebnis = { angewendet: [], fehlend: ['ausnahme'] };
		}
		if (!ergebnis) ergebnis = { angewendet: [], fehlend: [] };
		if (!Array.isArray(ergebnis.fehlend)) ergebnis.fehlend = [];
		if (!Array.isArray(ergebnis.angewendet)) ergebnis.angewendet = [];

		if (ergebnis.fehlend.length) {
			console.warn('[PROJ-99] ' + optionen.name + ': nicht uebernommen:', ergebnis.fehlend.join(', '));
			helfer.hinweis(HINWEIS_TEILWEISE);
		}

		helfer.knopfAnpassen(optionen.knopf);
		/* Testnaht (gleiches Muster wie citymap.js/starmap-celestial.js/jewelry-bearbeiten.js). */
		window.__dlBearbeitenErgebnis = { ok: true, ausConfig: ergebnis };
		return true;
	}

	/* ---------------------------------------------------------------- Abschluss */

	/* Nach einem erfolgreichen /cart/add.js im Bearbeiten-Modus: alte Zeile weg, Modus zu,
	   Drawer auf (macht alles cart-edit.js). Hier nur die Knopf-Nachsorge, die in jedem Editor
	   gleich ist: kurze Bestaetigung, dann der Originaltext, den der Helfer am Knopf hinterlegt
	   hat. Rueckgabe: das Ergebnis von abschliessen() (false = alte Zeile blieb liegen, der Helfer
	   hat den Hinweis gezeigt und den Knopf freigegeben; der Editor laeuft normal weiter). */
	async function abschliessen(knopf, cartAntwort) {
		var helfer = window.DLCartEdit;
		if (!helfer) return false;
		if (knopf) knopf.textContent = 'Änderung wird übernommen...';
		var uebernommen = await helfer.abschliessen(cartAntwort);
		if (uebernommen && knopf) {
			var originaltext = knopf.dataset.dlOriginaltext || 'In den Warenkorb';
			knopf.textContent = '✓ Änderung übernommen!';
			setTimeout(function () {
				knopf.textContent = originaltext;
				knopf.disabled = false;
				knopf.style.pointerEvents = 'auto';
			}, 2000);
		}
		return uebernommen;
	}

	window.DLPosterBearbeiten = {
		istModus: IST_MODUS,
		HINWEIS_TEILWEISE: HINWEIS_TEILWEISE,
		knopfSperren: knopfSperren,
		selektorWert: selektorWert,
		zuschnittLesen: zuschnittLesen,
		feldSetzen: feldSetzen,
		feldSetzenElement: feldSetzenElement,
		kachelKlicken: kachelKlicken,
		formatAnwenden: formatAnwenden,
		starten: starten,
		abschliessen: abschliessen
	};
})();
